import React from 'react';

const Attachment = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='13'
      height='15'
      viewBox='0 0 13 15'
      fill='none'
      {...props}
    >
      <path
        d='M12.394 7.89076L7.83507 12.4497C6.32435 13.9605 3.87501 13.9605 2.36429 12.4497C0.853581 10.939 0.853581 8.48968 2.36429 6.97897L7.70481 1.63845C8.71195 0.63131 10.3449 0.63131 11.352 1.63845C12.3591 2.64559 12.3591 4.27849 11.352 5.28563L6.01148 10.6262C5.5079 11.1297 4.69145 11.1297 4.18788 10.6262C3.68431 10.1226 3.68431 9.30613 4.18788 8.80256L9.5284 3.46204'
        stroke='currentColor'
        stroke-linecap='round'
      />
    </svg>
  );
};

export default Attachment;
